/**
 * useEventsMap (TASK-251)
 *
 * Loads the publishable domain-event registry and exposes a
 * `codename → human label` map used by outgoing channel route-headers to render
 * configured trigger events with readable names.
 *
 * Shares the `['events']` query key with ChannelSection's EventsField, so the
 * registry is fetched once and served from cache to every consumer
 * (ChannelsPanel, IntegrationSettings).
 */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { eventsApi } from '@/services/api/events';

export function useEventsMap(): Record<string, string> {
  const { data: events } = useQuery({
    queryKey: ['events'],
    queryFn: eventsApi.list,
  });

  return useMemo(() => {
    const map: Record<string, string> = {};
    if (Array.isArray(events)) {
      for (const event of events) {
        map[event.codename] = event.label;
      }
    }
    return map;
  }, [events]);
}

export default useEventsMap;
